import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import store from './store';
import reportWebVitals from './reportWebVitals';
import {Provider} from "react-redux";
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary';
import { registerChunkErrorHandlers } from '@utils/chunkReload';

registerChunkErrorHandlers();

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <ErrorBoundary>
        <Provider store={store}>
            <App/>
        </Provider>
    </ErrorBoundary>
);

reportWebVitals();
